import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useFormikContext } from "formik";

import { calculateSum } from "../../CommonFuntion/TotalQuantity";
import { calculateInputSum } from "../../CommonFuntion/TotalQuantity";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,

    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 5,
    paddingRight: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

export function TableHeadFormik(props) {
  const {
    name,
    maxNoLines,
    prefix,
    totalSum,
    setTotalSum,
    purchasedQty,
    setPurchasedQty,
    setTotalInputSum,
    columnsWithAnyData,
    csvUplaodEnabled,
    csvEnableSchemas,
    schemaName,
    searchParams,
    imagePreviewRequired,
    Lines,
    schemaPageFields,
    setELCDropDown,
    ediEditableFields,
    ediReadonlyMode,
  } = props;

  const { values, setFieldValue } = useFormikContext();
  const ClearTable = () => {
    let table = values[name];
    table?.forEach((element) => {
      Object.entries(element)?.forEach(([key, value]) => {
        element[key] = "";
      });
    });
    const ELCData = schemaPageFields.filter((x) => x.prefix === "ELC");

    if (ELCData.length > 0) {
      let ELCDropDown = {};
      ELCData.forEach((x) => {
        ELCDropDown[x.schemaItem] = {
          keyValues: [],
          fieldName: x.fieldName,
          key: [],
        };
      });
      setELCDropDown(ELCDropDown);
    }
    setFieldValue(name, table);
    setTotalSum(calculateSum(props, table));
    setTotalInputSum(calculateInputSum(props, table));
  };

  const ClearCatalougeQuantity = (optn) => {
    let table = values[name];
    if (table) {
      table?.forEach((element) => {
        element[optn.fieldName] = "0";
      });
      setFieldValue(name, table);
      setTotalSum(calculateSum(props, table));
    }
  };

  const handleApplyAllClick = (optn) => {
    let i = 0;
    let table = values[name];
    table.forEach((x) => {
      const Input = table[0][optn.fieldName];
      if (Input !== "") {
        table[i][optn.fieldName] = Input;
        setFieldValue(`${name}[${i}].${optn.fieldName}`, Input);
        i += 1;
      }
    });
  };

  const ResetCatalougeQuantity = (optn) => {
    let table = values[name];
    if (table) {
      let index = 0;
      table?.forEach((element) => {
        element[optn.fieldName] = purchasedQty[index];
        index = index + 1;
      });
      setFieldValue(name, table);
      setTotalSum(calculateSum(props, table));
    }
  };
  const getFormElement = (optn, index) => {
    if (
      optn.fieldName !== "BTN" &&
      optn.display !== false &&
       optn.visible !== false &&
      (csvUplaodEnabled
        ? optn.prefix !== "STC"
          ? true
          : columnsWithAnyData && columnsWithAnyData.includes(optn.fieldName)
        : true)
    ) {
      if (optn.catalogueSchemaType === 16) {
        return (
          <>
            <StyledTableCell key={index}>
              <label
                className={
                  optn?.validation?.mandatory === true ? "required" : ""
                }
              >
                {optn.fieldName}
                {optn?.validation?.pictureMask
                  ? "(" + optn?.validation?.pictureMask.length + ")"
                  : ""}
              </label>

              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  onClick={() => ClearCatalougeQuantity(optn)}
                  component="label"
                  sx={{ textTransform: "none" }}
         size="small"
                >
                  Clear
                </Button>
              )}
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  component="label"
                  onClick={() => ResetCatalougeQuantity(optn)}
                  sx={{ textTransform: "none" }}
         size="small"
                >
                  Reset
                </Button>
              )}
            </StyledTableCell>
            <StyledTableCell key={"Wastage"}>
              <label>Wastage</label>
            </StyledTableCell>
          </>
        );
      } else if (optn.schemaType === 16) {
        return (
          <>
            <StyledTableCell key={"INQ"}>
              <label
                className={
                  optn?.validation?.mandatory === true ? "required" : ""
                }
              >
                {optn.fieldName}
                {optn?.validation?.pictureMask
                  ? "(" + optn?.validation?.pictureMask.length + ")"
                  : ""}
              </label>

              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  onClick={() => ClearCatalougeQuantity(optn)}
                  component="label"
                  sx={{ textTransform: "none" }}
         size="small"
                >
                  Clear
                </Button>
              )}
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  component="label"
                  onClick={() => ResetCatalougeQuantity(optn)}
                  sx={{ textTransform: "none" }}
         size="small"
                >
                  Reset
                </Button>
              )}
            </StyledTableCell>

            <StyledTableCell key={index}>
              <label>Input Quantity</label>
            </StyledTableCell>
          </>
        );
      } else if (
        csvUplaodEnabled &&
        optn.prefix !== "STC" &&
        optn?.validation?.mandatory
      ) {
        return (
          <>
            <StyledTableCell key={index}>
              <label
                className={
                  optn?.validation?.mandatory === true ? "required" : ""
                }
              >
                {optn.fieldName}
                {optn?.validation?.pictureMask
                  ? "(" + optn?.validation?.pictureMask.length + ")"
                  : ""}
              </label>
              <Button
                className="clearbtn"
                variant="contained"
                onClick={() => handleApplyAllClick(optn)}
                component="label"
              >
                Apply All
              </Button>
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  onClick={() => ClearCatalougeQuantity(optn)}
                  component="label"
                >
                  Clear
                </Button>
              )}
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  component="label"
                  onClick={() => ResetCatalougeQuantity(optn)}
                >
                  Reset
                </Button>
              )}
            </StyledTableCell>
          </>
        );
      } else {
        // Show "Apply All" for fields in editableFields (but not QTY prefix)
        const showApplyAll = ediReadonlyMode && Array.isArray(ediEditableFields)
          && ediEditableFields.includes(optn.fieldName) && optn.prefix !== "QTY";
        return (
          <>
            <StyledTableCell key={index}>
              <label
                className={
                  optn?.validation?.mandatory === true ? "required" : ""
                }
              >
                {optn.fieldName}
                {optn?.validation?.pictureMask
                  ? "(" + optn?.validation?.pictureMask.length + ")"
                  : ""}
              </label>

              {showApplyAll && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  onClick={() => handleApplyAllClick(optn)}
                  component="label"
                  sx={{ textTransform: "none" }}
                  size="small"
                >
                  Apply All
                </Button>
              )}
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  onClick={() => ClearCatalougeQuantity(optn)}
                  component="label"
                >
                  Clear
                </Button>
              )}
              {optn.catalogueSchemaType === 16 && (
                <Button
                  className="clearbtn"
                  variant="contained"
                  component="label"
                  onClick={() => ResetCatalougeQuantity(optn)}
                >
                  Reset
                </Button>
              )}
            </StyledTableCell>
          </>
        );
      }
    }
    if (optn.fieldName === "BTN") {
      return (
        <Button
          className="clearbtn"
          variant="contained"
          component="label"
          onClick={ClearTable}
        >
          {" "}
          Clear Table
        </Button>
      );
    }
  };

  return (
    <TableHead>
      <TableRow>
        {prefix !== "CTB" && Lines > 1 && (
          <StyledTableCell>Line #</StyledTableCell>
        )}
        {imagePreviewRequired && Lines > 1 && (
          <StyledTableCell>Image Preview</StyledTableCell>
        )}
        {props.schemaPageFields &&
          props.schemaPageFields.map((optn, index) => (
            <React.Fragment key={optn.fieldName || index}>
              {getFormElement(optn, index)}
            </React.Fragment>
          ))}
        {props.schemaPageFields &&
          props.schemaPageFields.map(
            (optn, index) =>
              optn.prefix === "QTY" && (
                <StyledTableCell key={index}>
                  <label>Wastage</label>
                </StyledTableCell>
              )
          )}

        {prefix !== "CTB" && maxNoLines > 1 && (
          <>
            <StyledTableCell>
              <Button
                className="clearbtn"
                variant="contained"
                component="label"
                onClick={ClearTable}
              >
                Clear Table
              </Button>
            </StyledTableCell>
          </>
        )}
      </TableRow>
    </TableHead>
  );
}

export default TableHeadFormik;
